import { ThankYouPageSettingOutputApiModel } from './thank-you-page-setting-output.api-model';
import { QuestionnaireOutApiModel } from './questionnaire-output.api-model';

export interface StorySettingOutputApiModel {
  thank_you_page: ThankYouPageSettingOutputApiModel;
  questionnaires: QuestionnaireOutApiModel[];
  inbound_story_allowed: boolean;
  submit_button_enable: boolean;
  story_public_enabled: boolean;
}
